export default __webpack_public_path__ + "static/media/1739.71180f55.png";